module.exports = __webpack_public_path__ + "img/process-5.bc716597.jpg";